import { useUserStore } from "@/stores/use-user-store";
import { buildDepartmentRoute } from "@/utils/department-routes";
import { getFirstUserDepartment } from "@/utils/user-positions";

import { useDepartmentRoute } from "./use-department-route";

export function useDepartmentLink({
  shouldGetDepartmentFromUrl = true,
}: {
  shouldGetDepartmentFromUrl?: boolean;
} = {}) {
  const activeUser = useUserStore((state) => state.activeUser);
  const { departmentSlug } = useDepartmentRoute();

  return (path: string) => {
    if (!activeUser) {
      return path;
    }

    const department =
      shouldGetDepartmentFromUrl && departmentSlug ? departmentSlug : getFirstUserDepartment(activeUser);

    if (!department) {
      return path;
    }

    return buildDepartmentRoute(department, path);
  };
}
